// import React, { useState, useEffect } from 'react';
// import { Bar } from 'react-chartjs-2';
// import { Chart, registerables } from 'chart.js';
// import axiosInstance from '../axiosInstance';
// import Cookies from 'js-cookie';
// import { FiRefreshCw, FiInfo } from 'react-icons/fi';

// Chart.register(...registerables);

// const GovernmentSpendingGraph = () => {
//   const currentYear = new Date().getFullYear();
//   const [graphData, setGraphData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [hoveredBar, setHoveredBar] = useState(null);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [showTooltip, setShowTooltip] = useState(false);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setIsRefreshing(true);
//       const response = await axiosInstance.get(`/graph/getGraphdata`, {
//         headers: {
//           'x-auth-token': localStorage.getItem('token'),
//           'x-report-id': Cookies.get('reportId'),
//         }
//       });
//       setGraphData(response.data?.data || []);
//       setError('');
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load graph data. Please try again.");
//     } finally {
//       setLoading(false);
//       setIsRefreshing(false);
//     }
//   };

//   useEffect(() => { fetchData(); }, []);

//   const truncateLabel = (label, maxLength = 12) => {
//     return label.length > maxLength ? `${label.substring(0, maxLength)}...` : label;
//   };

//   const sortedData = [...graphData].sort((a, b) => b.cost - a.cost);
//   const totalSpending = sortedData.reduce((sum, item) => sum + item.cost, 0);
//   const averageSpending = totalSpending / sortedData.length;

//   if (loading) return (
//     <div className="w-full bg-gray-900 rounded-lg border border-gray-700">
//       <div className="h-64 bg-gray-800/50 animate-pulse"></div>
//     </div>
//   );

//   if (error) return (
//     <div className="w-full bg-gray-900 rounded-lg border border-gray-700 p-3 text-center">
//       <p className="text-red-400 mb-2 text-sm">{error}</p>
//       <button 
//         onClick={fetchData}
//         className="text-blue-400 hover:text-blue-300 text-sm flex items-center justify-center mx-auto"
//       >
//         <FiRefreshCw className={`mr-1 ${isRefreshing ? 'animate-spin' : ''}`} />
//         Try Again
//       </button>
//     </div>
//   );

//   if (!sortedData.length) return (
//     <div className="w-full bg-gray-900 rounded-lg border border-gray-700 p-3 text-center">
//       <p className="text-gray-400 text-sm">No data available</p>
//     </div>
//   );

//   const chartData = {
//     labels: sortedData.map(item => truncateLabel(item.sector)),
//     datasets: [{
//       label: 'Cost (billions)',
//       data: sortedData.map(item => item.cost),
//       backgroundColor: sortedData.map((_, i) => 
//         i === 0 ? '#10b981' : 
//         i === sortedData.length - 1 ? '#ef4444' : 
//         hoveredBar === i ? '#60a5fa' : '#3b82f6'
//       ),
//       borderColor: sortedData.map((_, i) => 
//         i === 0 ? '#059669' : 
//         i === sortedData.length - 1 ? '#dc2626' : 
//         hoveredBar === i ? '#2563eb' : '#1e40af'
//       ),
//       borderWidth: 1,
//       borderRadius: 4,
//       hoverBorderWidth: 2,
//     }]
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         callbacks: {
//           title: ([context]) => sortedData[context.dataIndex].sector,
//           label: (context) => `$${context.raw.toFixed(2)}B`,
//           footer: (context) => {
//             const percentage = ((context[0].raw / totalSpending) * 100);
//             return `${percentage.toFixed(1)}% of total`;
//           }
//         },
//         backgroundColor: '#111827',
//         titleColor: '#f3f4f6',
//         bodyColor: '#f3f4f6',
//         borderColor: '#374151',
//         padding: 8,
//         cornerRadius: 6,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: { 
//           color: '#9ca3af',
//           callback: (value) => `$${value}B`,
//           font: { size: 11 }
//         },
//         grid: { color: '#374151' },
//       },
//       x: {
//         ticks: { 
//           color: '#9ca3af',
//           callback: (_, index) => truncateLabel(sortedData[index].sector),
//           font: { size: 11 }
//         },
//         grid: { display: false },
//       }
//     },
//     onHover: (_, elements) => setHoveredBar(elements[0]?.index),
//   };

//   return (
//     <div className="w-full bg-gray-800 rounded-lg border border-gray-700">
//       {/* Compact Header */}
//       <div className="flex justify-between items-center p-2 border-b border-gray-700">
//         <div className="flex-1 text-center">
//           <h3 className="text-sm font-semibold text-white">Government Spending {currentYear}</h3>
//         </div>
//         <div className="flex items-center space-x-2">
//           <button 
//             onClick={fetchData}
//             className="text-gray-400 hover:text-gray-300 p-1"
//             title="Refresh"
//           >
//             <FiRefreshCw size={14} className={isRefreshing ? 'animate-spin' : ''} />
//           </button>
//           <div className="relative">
//             <FiInfo 
//               size={14} 
//               className="text-gray-400 hover:text-gray-300 cursor-pointer" 
//               onMouseEnter={() => setShowTooltip(true)}
//               onMouseLeave={() => setShowTooltip(false)}
//             />
//             {showTooltip && (
//               <div className="absolute z-10 right-0 mt-1 w-40 bg-gray-800 text-xs text-gray-300 p-2 rounded border border-gray-700">
//                 <p>Total Sectors: {sortedData.length}</p>
//                 <p>Top Sector: {truncateLabel(sortedData[0]?.sector)}</p>
//                 <p>Hover bars for details</p>
//                 <p>Green = Top sector</p>
//                 <p>Red = Lowest sector</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Tight Summary */}
//       <div className="grid grid-cols-3 gap-1 px-2 py-1 text-center border-b border-gray-700">
//         <div>
//           <p className="text-xs text-gray-400">Total</p>
//           <p className="text-sm font-medium text-white">${totalSpending.toFixed(1)}B</p>
//         </div>
//         <div>
//           <p className="text-xs text-gray-400">Average</p>
//           <p className="text-sm font-medium text-white">${averageSpending.toFixed(1)}B</p>
//         </div>
//         <div>
//           <p className="text-xs text-gray-400">Top Sector</p>
//           <p className="text-sm font-medium text-green-400 truncate" title={sortedData[0]?.sector}>
//             {truncateLabel(sortedData[0]?.sector, 10)}
//           </p>
//         </div>
//       </div>

//       {/* Main Chart */}
//       <div className="h-72 p-1">
//         <Bar data={chartData} options={options} />
//       </div>

//       {/* Minimal Footer */}
//       <div className="text-xs text-gray-500 text-center p-1 border-t border-gray-700">
//         Updated: {new Date().toLocaleTimeString()}
//       </div>
//     </div>
//   );
// };

// export default GovernmentSpendingGraph;

import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import axiosInstance from '../axiosInstance';
import Cookies from 'js-cookie';

Chart.register(...registerables);

const GovernmentSpendingGraph = () => {
  const currentYear = new Date().getFullYear();
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`/graph/getGraphdata`, {
          headers: {
            'x-auth-token': localStorage.getItem('token'),
            'x-report-id': Cookies.get('reportId'),
          }
        });

        setGraphData(response.data?.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load graph data. Please try again.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <p style={{ color: '#fff', textAlign: 'center' }}>Loading data...</p>;
  }

  if (error) {
    return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
  }

  if (!Array.isArray(graphData) || graphData.length === 0) {
    return <p style={{ color: '#f3f4f6', textAlign: 'center' }}>No data available for the graph.</p>;
  }

  const chartData = {
    labels: graphData.map((item) => item.sector),
    datasets: [
      {
        label: 'Costs (in billions)',
        data: graphData.map((item) => item.cost),
        backgroundColor: '#3b82f6',
        borderColor: '#3b82f6',
        borderWidth: 1,
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: '#374151' },
        ticks: { color: '#f3f4f6', font: { size: 12 } },
        title: {
          display: true,
          text: 'Costs (in billions)',
          color: '#f3f4f6',
          font: { size: 14, weight: 'bold' },
        },
      },
      x: {
        grid: { display: false },
        ticks: { color: '#f3f4f6', font: { size: 12 } },
        title: {
          display: true,
          text: 'Sector',
          color: '#f3f4f6',
          font: { size: 14, weight: 'bold' },
        },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#111827',
        titleColor: '#f3f4f6',
        bodyColor: '#f3f4f6',
        titleFont: { size: 14 },
        bodyFont: { size: 12 },
        padding: 10,
        cornerRadius: 6,
      },
    },
  };

  return (
    <div style={{ 
      width: '100%', 
      maxWidth: '900px', 
      margin: 'auto', 
      padding: '20px', 
      borderRadius: '12px', 
      backgroundColor: '#1f2937', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)', 
    }}>
      <h2 style={{ 
        textAlign: 'center', 
        marginBottom: '20px', 
        fontSize: '24px', 
        fontWeight: 'bold', 
        color: '#f3f4f6', 
      }}>
        Government Spending Sectors ({currentYear})
      </h2>
      <div style={{ height: '300px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default GovernmentSpendingGraph;
